// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"u8-z"};